<div class="spdcForm-row spdcForm-row_2up">
        <div class="spdcForm-row-item isRequired{{#if @root.errors.firstName}} spdcForm-row-item_hasErrors{{/if}}">
            <label class="spdcForm-lbl">First Name</label>
            <input class="spdcForm-input js-element--firstName" type="text" />
            <div class="spdcForm-msg spdcForm-msg_error">{{@root.errors.firstName}}</div>
        </div>
        <div class="spdcForm-row-item isRequired{{#if @root.errors.lastName}} spdcForm-row-item_hasErrors{{/if}}">
            <label class="spdcForm-lbl">Last Name</label>
            <input class="spdcForm-input js-element--lastName" type="text" />
            <div class="spdcForm-msg spdcForm-msg_error">{{@root.errors.lastName}}</div>
        </div>
    </div>
    <div class="spdcForm-row">
        <div class="spdcForm-row-item isRequired{{#if @root.errors.address}} spdcForm-row-item_hasErrors{{/if}}">
            <label class="spdcForm-lbl">Address</label>
            <input class="spdcForm-input js-element--address1" type="text" />
            <div class="spdcForm-msg spdcForm-msg_error">{{@root.errors.address}}</div>
        </div>
    </div>
    <div class="spdcForm-row">
        <div class="spdcForm-row-item">
            <label class="spdcForm-lbl">Address 2 (optional)</label>
            <input class="spdcForm-input js-element--address2" type="text" />
        </div>
    </div>
    <div class="spdcForm-row spdcForm-row_2up">
        <div class="spdcForm-row-item isRequired{{#if @root.errors.country}} spdcForm-row-item_hasErrors{{/if}}">
            <label class="spdcForm-lbl">Country</label>
            <select class="spdcForm-select js-element--country">
                {{#if country}}
                    <option value="{{country.id}}" selected="true">{{country.name}}</option>
                {{/if}}
                {{#each countries}}
                    <option value="{{id}}">{{name}}</option>
                {{/each}}
            </select>
            <div class="spdcForm-msg spdcForm-msg_error">{{@root.errors.country}}</div>
        </div>
        <div class="spdcForm-row-item isRequired{{#if @root.errors.state}} spdcForm-row-item_hasErrors{{/if}}">
            {{#if country.hasRegions}}
                <label class="spdcForm-lbl">State / Region</label>
                <select class="spdcForm-select js-element--state">
                    {{#if state}}
                        <option value="{{state.id}}" selected="true">{{state.name}}</option>
                    {{else}}
                        <option value="">Select One</option>
                    {{/if}}
                    {{#each states}}
                        <option value="{{id}}">{{name}}</option>
                    {{/each}}
                </select>
                <div class="spdcForm-msg spdcForm-msg_error">{{@root.errors.state}}</div>
            {{/if}}
        </div>
    </div>
    <div class="spdcForm-row spdcForm-row_2up">
        <div class="spdcForm-row-item isRequired{{#if @root.errors.city}} spdcForm-row-item_hasErrors{{/if}}">
            <label class="spdcForm-lbl">City</label>
            <input class="spdcForm-input js-element--city" type="text" />
            <div class="spdcForm-msg spdcForm-msg_error">{{@root.errors.city}}</div>
        </div>
        <div class="spdcForm-row-item isRequired{{#if @root.errors.postalCode}} spdcForm-row-item_hasErrors{{/if}}">
            {{#if country.hasPostalCodes}}
                <label class="spdcForm-lbl">Postal / Zip Code</label>
                <input class="spdcForm-input js-element--zip" value="{{#if postalCode}}{{postalCode}}{{/if}}" type="text" />
                <div class="spdcForm-msg spdcForm-msg_error">{{@root.errors.postalCode}}</div>
            {{/if}}
        </div>
    </div>
    <div class="spdcForm-row spdcForm-row_2up">
        <div class="spdcForm-row-item isRequired{{#if @root.errors.phone}} spdcForm-row-item_hasErrors{{/if}}">
            <label class="spdcForm-lbl">Phone</label>
            <input class="spdcForm-input js-element--phone" type="tel" />
            <div class="spdcForm-msg spdcForm-msg_error">{{@root.errors.phone}}</div>
        </div>
        <div class="spdcForm-row-item">
            <input class="spdcForm-btn js-action--submit-new-address" type="submit" value="Save Address & Get Estimate">
        </div>
    </div>